import { HttpService } from './../shared/http.service';
import { Verification } from '../settings/verification';
import { Location } from '@angular/common';
import { Http, RequestOptions, Headers, HttpModule } from '@angular/http';
import { AuthService, User } from '../user/auth.service';
import { Subject } from 'rxjs/Subject';
import { RegistryFirebaseService } from '../registry/registry-firebase.service';
import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { RegistryService } from '../registry/registry.service';
import { ConfigurationService } from '../shared/configuration.service';
import { AnalyticsService } from '../analytics/analytics.service';
import { Registry } from '../registry/registry';
import { Settings } from '../settings/settings';
import { ToastType } from '../toast/toast.enum';
import { environment } from '../../environments/environment';
import { Contribution } from '../track/contribution';
import { Gift } from '../gift/gift';
import { ActivatedRoute, Router, RouterEvent, NavigationEnd } from '@angular/router';
import { UserService } from '../user/user.service';

@Component({
  selector: 'app-account-payment-payment',
  templateUrl: './account-payment-methods.component.html',
  styleUrls: ['./account-payment-methods.component.scss']
})
export class AccountPaymentMethodsComponent implements OnInit, OnDestroy {
  private readonly USE_PAYENGINE = true;

  get usePayEngine(): boolean {
    return this.USE_PAYENGINE;
  }

  pricingTextLight: string;
  registry: Registry;
  // recAmountSaved = false;
  showPopup = false;
  anonymousCouple = false;
  unbpulishedDueToRemovingPaymentMethods = false;

  processing = false;

  reasonError: string;

  payId: string;
  redirecting = false;
  paypal: string;
  requiresIdBeforeChargesEnabled = false;
  venmo: string;
  wise: string;
  cashApp: string;
  generalInstructions: string;
  bitcoin: string;
  settings: Settings;
  customInstructions: string;
  customInstructionsLabel: string;
  numOfCustomPaymentMethods = 0;
  zelle: string;
  revolut: string;
  cashOnTheDay: string;
  chequeOnTheDay: string;

  editVenmo = false;
  editCashApp = false;
  editWise = false;
  editZelle = false;
  editRevolut = false;
  editPaypal = false;
  editBitcoin = false;
  editBank1 = false;
  editBank2 = false;
  editBank3 = false;

  editPayId = false;
  editCashOnDay = false;
  editChequeOnDay = false;
  editCustomInstructions = false;
  editGeneralInstructions = false;
  showGeneralInstructionsEditor = false;
  token: string;
  stripeProcessing: boolean;
  email: string;



  bankField1: string;
  bankField2: string;
  bankField3: string;
  bankField4: string;
  bankCountry: string;

  bankTitleField1: string;
  bankTitleField2: string;
  bankTitleField3: string;
  bankTitleField4: string;

  bank2Field1: string;
  bank2Field2: string;
  bank2Field3: string;
  bank2Field4: string;
  bank2Country: string;

  bank2TitleField1: string;
  bank2TitleField2: string;
  bank2TitleField3: string;
  bank2TitleField4: string;

  bank3Field1: string;
  bank3Field2: string;
  bank3Field3: string;
  bank3Field4: string;
  bank3Country: string;

  bank3TitleField1: string;
  bank3TitleField2: string;
  bank3TitleField3: string;
  bank3TitleField4: string;
  show2ndBankTransfer: boolean;
  show3rdBankTransfer: boolean;
  currentPosition: number;
  hideMobileMenu: boolean;

  @HostListener('window:scroll', ['$event'])
  onWindowScroll(e: Event) {

    let scroll = window.pageYOffset || document.documentElement.scrollTop;

    if (scroll > this.currentPosition && (scroll > 2)) {
      this.hideMobileMenu = true;
    } else {
      this.hideMobileMenu = false;
    }

    this.currentPosition = scroll;

  }
  constructor(
    private _registryFirebaseService: RegistryFirebaseService,
    private _configuration: ConfigurationService,
    private _analyticsService: AnalyticsService,
    private _authService: AuthService,
    private _registryService: RegistryService,
    private route: ActivatedRoute,
    private _router: Router,
    private _http: Http,
    private _userService: UserService
  ) {
    this.showPopup = false;
    this._router.events.filter(event => event instanceof NavigationEnd).subscribe((event: any) => {
      this.showPopup = true;
      this._authService.authToken().subscribe(token => {
        this.token = token;
      });
      document.title = 'Account | Hitchd';
      //  this.loadForm();
      if (!this.registry) {
        this.registry = this._registryFirebaseService.registry;
      }
      if (this.registry && this.registry.country) {
        this.setPricingFaqLight();
      }
    });
    this.unbpulishedDueToRemovingPaymentMethods = false;
    this._authService.user.subscribe((user: User) => {
      this.email = user.email;
    });
  }

  showGeneralEditor() {
    if (!this.generalInstructions) {
      this.editGeneralInstructions = false;
    }
    this.editGeneralInstructions = true;
    this.showGeneralInstructionsEditor = true

  }
  checkNumberOfCustomPaymentMethods() {

    this.numOfCustomPaymentMethods = 0;
    if (this.registry.cashApp) {
      this.numOfCustomPaymentMethods++;

    }
    if (this.registry.bitcoin) {
      this.numOfCustomPaymentMethods++;

    }

    if (this.registry.paypal) {
      this.numOfCustomPaymentMethods++;

    }


    if (this.registry.venmo) {
      this.numOfCustomPaymentMethods++;

    }


    if (this.registry.customInstructions) {
      this.numOfCustomPaymentMethods++;

    }
    if (this.registry.bankField1) {
      this.numOfCustomPaymentMethods++;

    }


    if (this.registry.cashOnTheDay) {
      this.numOfCustomPaymentMethods++;

    }



    if (this.registry.chequeOnTheDay) {
      this.numOfCustomPaymentMethods++;

    }



    if (this.registry.revolut) {
      this.numOfCustomPaymentMethods++;

    }
    if (this.registry.zelle) {
      this.numOfCustomPaymentMethods++;

    }
    if (this.registry.payId) {
      this.numOfCustomPaymentMethods++;

    }
    if (this.registry.wise) {
      this.numOfCustomPaymentMethods++;

    }
    if (this.registry.generalInstructions) {
      this.numOfCustomPaymentMethods++;

    }

    return this.numOfCustomPaymentMethods;
  }
  load() {

    if (!this.registry) {
      return;
    }
    this.bankField1 = this.registry.bankField1;
    this.bankField2 = this.registry.bankField2;
    this.bankField3 = this.registry.bankField3;
    this.bankField4 = this.registry.bankField4;


    this.bank2Field1 = this.registry.bank2Field1;
    this.bank2Field2 = this.registry.bank2Field2;
    this.bank2Field3 = this.registry.bank2Field3;
    this.bank2Field4 = this.registry.bank2Field4;

    this.bank3Field1 = this.registry.bank3Field1;
    this.bank3Field2 = this.registry.bank3Field2;
    this.bank3Field3 = this.registry.bank3Field3;
    this.bank3Field4 = this.registry.bank3Field4;

    this.bankCountry = this.registry.bankCountry ? this.registry.bankCountry : this.registry.country;

    this.bank2Country = this.registry.bank2Country;
    this.bank3Country = this.registry.bank3Country;

    if (this.bank2Field1 && this.bank2Country) {
      this.changeCountryBankField2()
    }
    if (this.bank3Field1 && this.bank3Country) {
      this.changeCountryBankField3();
    }
    this.cashApp = this.registry.cashApp;
    this.bitcoin = this.registry.bitcoin;
    this.venmo = this.registry.venmo;
    this.paypal = this.registry.paypal;
    this.customInstructions = this.registry.customInstructions;
    this.customInstructionsLabel = this.registry.customInstructionsLabel;
    this.wise = this.registry.wise;

    this.revolut = this.registry.revolut;
    this.zelle = this.registry.zelle;
    this.cashOnTheDay = this.registry.cashOnTheDay;
    this.chequeOnTheDay = this.registry.chequeOnTheDay;
    this.payId = this.registry.payId;
    this.generalInstructions = this.registry.generalInstructions;
    this._registryFirebaseService.getSettings().subscribe(settings => {

      this.settings = settings;
      this.requiresIdVerificationBeforeChanrgesEnabled();
      this.checkForErrorsAndExtractReasonText();
    });

  }

  checkForErrorsAndExtractReasonText() {
    return;
    //   this.reasonError = '';
    //   const data = this.settings.verification;
    // let reason;
    // if (data.errors && data.errors[0]) {
    //   reason = data.errors[0].reason;  
    // }
    // this.reasonError = reason;
    // return reason;
  }

  ngOnInit() {
    // ;
    ;
    this.registry = this.route.snapshot.data.registry;
    if (location.pathname.includes('/your-registry')) {
      this.anonymousCouple = true;
    }
    if (!this.registry && !this.anonymousCouple) {
      this.registry = this._registryFirebaseService.registry;

    } else if (!this.registry && this.anonymousCouple) {
      this.registry = this._registryFirebaseService.getAnonRegistry();
      this.registry.paid = false;
    } else {
      this.setPricingFaqLight();
    }

    if (!this.anonymousCouple && this.registry && this.registry.country) {

      this.setPaymentMethodTitles();

      if (this.bank2Country) {
        this.changeCountryBankField2();
      }
      if (this.bank3Country) {
        this.changeCountryBankField3();
      }
      this.load();
      this.checkNumberOfCustomPaymentMethods();
    }
  }
  dataChanged(newObj) {
    // here comes the object as parameter
  }





  ngOnDestroy() {
    console.log('destroyed')
  }

  requiresIdVerificationBeforeChanrgesEnabled() {


    this.requiresIdBeforeChargesEnabled = this.settings && this.settings.verification

      && this.settings.verification.fields_needed
      && this.settings.verification.fields_needed.includes('legal_entity.verification.document');
  }
  openMobileMenu() {
    this._userService.emitUpdateHeaderType('showMobileMenu');
  }
  close() {
    // ;

    console.log('close clicked')
    // const body = document.getElementsByTagName('body')[0];
    // body.style.overflow = 'auto';
    this.showPopup = false;

    if (this.anonymousCouple) {
      return this._router.navigate(['/your-registry']);
    } else {
      return this._router.navigate(['/registry']);
    }



  }

  addAnotherBank() {
    if (this.show2ndBankTransfer) {
      this.show3rdBankTransfer = true;
    } else {
      this.show2ndBankTransfer = true;
    }
  }


  setPaymentMethodTitles() {
    ;
    this.bankTitleField1 = null;
    this.bankTitleField2 = null;
    this.bankTitleField3 = null;
    this.bankTitleField4 = null;
    let bank1Country = this.registry.bankCountry ? this.registry.bankCountry : this.registry.country;
    const titles = this._registryService.getBankFieldTitles(bank1Country);
    this.bankTitleField1 = titles.field1;
    this.bankTitleField2 = titles.field2;
    this.bankTitleField3 = titles.field3;
    this.bankTitleField4 = titles.field4;
  }

  changeCountryBankField2() {

    this.bank2TitleField1 = null;
    this.bank2TitleField2 = null;
    this.bank2TitleField3 = null;
    this.bank2TitleField4 = null;
    const titles = this._registryService.getBankFieldTitles(this.bank2Country);
    this.bank2TitleField1 = titles.field1;
    this.bank2TitleField2 = titles.field2;
    this.bank2TitleField3 = titles.field3;
    this.bank2TitleField4 = titles.field4;

  }


  changeCountryBankField3() {

    this.bank3TitleField1 = null;
    this.bank3TitleField2 = null;
    this.bank3TitleField3 = null;
    this.bank3TitleField4 = null;
    const titles = this._registryService.getBankFieldTitles(this.bank3Country);

    this.bank3TitleField1 = titles.field1;
    this.bank3TitleField2 = titles.field2;
    this.bank3TitleField3 = titles.field3;
    this.bank3TitleField4 = titles.field4;
  }
  changeCountryBankField() {

    this.bankTitleField1 = null;
    this.bankTitleField2 = null;
    this.bankTitleField3 = null;
    this.bankTitleField4 = null;
    const titles = this._registryService.getBankFieldTitles(this.bankCountry);
    this.bankTitleField1 = titles.field1;
    this.bankTitleField2 = titles.field2;
    this.bankTitleField3 = titles.field3;
    this.bankTitleField4 = titles.field4;
  }
  openSignup() {
    this._registryService.emitGenricPopup('anon_signup');
  }
  addOrRemoveCustomPaymentMethod(methodName: string, isRemove: boolean) {

    if (!isRemove) {

      this.registry.hasCustomPaymentMethods = true;
      this._analyticsService.trackEvent('Payment Method Added', { payment_method_name: methodName });
      this.unbpulishedDueToRemovingPaymentMethods = false;

    } else {

      this.numOfCustomPaymentMethods = this.checkNumberOfCustomPaymentMethods();
      this._analyticsService.trackEvent('Payment Method Removed', { payment_method_name: methodName });
      if (this.numOfCustomPaymentMethods == 0 && (!this.settings.stripeAccountId)) {
        this.registry.hasCustomPaymentMethods = false;

        if (this.registry.isLive) {
          this.registry.isLive = null;
          this.unbpulishedDueToRemovingPaymentMethods = true;
        }
      }

    }

    if (this.anonymousCouple) {
      this._registryFirebaseService.saveAnonRegistry(this.registry);
      return this._registryService.emitGenricPopup('anon_signup');

    } else {
      this._analyticsService.identifyById(this.registry.userId, { customPaymentMethodCount: this.numOfCustomPaymentMethods });
      this._registryFirebaseService.saveRegistry(this.registry).then(() => {

      });
      this.checkNumberOfCustomPaymentMethods();
    }



  }


  removeCreditCardPaymentMethod() {
    this.processing = true;
    let currentToken = null;
    this._authService.authToken().take(1).subscribe(token => {
      currentToken = token;

      return this._http
        .post(environment.firebase.clouldFunctionHost + '/disableCreditCardPaymentMethod', {
          idToken: currentToken,
          merchantId: this.settings.merchantId,
        })
        .toPromise()
        .then((response: any) => {
          ;
          this.processing = false;
          this.checkNumberOfCustomPaymentMethods();
        })
        .catch((e: any) => {
          this.processing = false;
          throw e;
        });

    });

  }

  unlinkStripe() {
    let currentToken = null;
    this.processing = true;
    this._authService.authToken().take(1).subscribe(token => {
      currentToken = token;


      return this._http
        .post(environment.firebase.clouldFunctionHost + '/unLinkStripeAccount', {
          token: currentToken,

        })
        .toPromise()
        .then((response: any) => {
          ;
          this.processing = false;
          this.checkNumberOfCustomPaymentMethods();
          if (this.numOfCustomPaymentMethods == 0 && this.registry.isLive) {
            this.unbpulishedDueToRemovingPaymentMethods = true;
          }
        })
        .catch((e: any) => {
          this.processing = false;

          throw e;


        });


    });
  }

  getGuestFee(feeOption: number) {
    switch (feeOption) {
      case 1: { return 0; }
      case 2: { return 4; }
      case 3: { return 8; }
    }
  }

  getCoupleFee(feeOption: number) {
    switch (feeOption) {
      case 1: { return 8; }
      case 2: { return 4; }
      case 3: { return 0; }
    }
  }

  saveFeeOption(feeOption: number) {
    this.processing = true;
    if (!this.settings) {
      console.error('no settings file found')
    }
    this.settings.feeOption = feeOption;
    this._registryFirebaseService.saveSettings(this.settings);
    this.processing = false;

    setTimeout(() => {
      this.processing = false;
    }, 1 * 1000);
  }

  setFeeGuestPay() {

    this.settings.feeOption = 3;

  }
  setFeeToAbsorb() {
    this.settings.feeOption = 1;
  }


  setPricingFaqLight() {
    this.pricingTextLight = '';
    switch (this.registry.country) {
      case 'AU': {
        this.pricingTextLight =
          '1.7% + $0.30';
        break;
      }
      case 'MX': {
        this.pricingTextLight =
          '3.6% + MXN$3';
        break;
      }
      case 'DK': {
        this.pricingTextLight =
          '1.4% + Kr 1.8';
        break;
      }
      case 'SE': {
        this.pricingTextLight =
          '1.4% + Kr 1.8';
        break;
      }
      case 'NO': {
        this.pricingTextLight =
          '2.4% + Kr 2';
        break;
      }
      case 'CH': {
        this.pricingTextLight =
          '2.9% + CHF 0.30';
        break;
      }
      case 'US': {
        this.pricingTextLight = '2.9% + $0.30';
        break;
      }
      case 'CA': {
        this.pricingTextLight =
          '2.9% + $0.30';
        break;
      }
      case 'NZ': {
        this.pricingTextLight = '2.9% + $0.30';
        break;
      }
      case 'HK': {
        this.pricingTextLight = '3.4% + $2.35';
        break;
      }
      case 'GB': {
        this.pricingTextLight =
          '1.4% + £0.20';
        break;
      }
      case 'JP': {
        this.pricingTextLight = '3.6%';
        break;
      }
      case 'SG': {
        this.pricingTextLight = '3.4% + $0.50';
        break;
      }
      case 'IE': {
        this.pricingTextLight =
          '1.5% + €0.25 - Excl VAT'
        break;
      }
      default: {
        this.pricingTextLight =
          '1.5% + €0.25'
        break;
      }
    }
  }


  setupStripe(skipRedirect = false): Promise<any> {

    let existingStripeAccountId = this.settings.stripeAccountId
    //this.linkStripeError = false;
    const country = this.registry.country;
    const currency = this.registry.currency;
    const registryName = this.registry.registryName;
    const email = encodeURI(this.email.replace(/[\n\t\r]/g, ''));
    //
    //   + 'country=' + country
    //   + '&currency=' + currency
    //   + '&registryName=' + registryName
    //   + '&email=' + email.trim()



    return this._http
      .post(environment.firebase.clouldFunctionHost + '/stripeOnboard', {
        country: country,
        currency: currency,
        registryName: registryName,
        email: email,
        rid: this.registry.id,
        tid: this.token,
        existingStripeAccountId: existingStripeAccountId
      })
      .toPromise()
      .then((response: any) => {
        const stripeResponse: any = response.json();

        if (!skipRedirect) {
          location.href = stripeResponse.url;
        }

      })
      .catch((e: any) => {
        const error = JSON.parse(e._body);
        if (error.code === 'account_already_exists') {

          this.stripeProcessing = false;
        }
        else {
          throw e;
        }
      });

  }

  launch() {

    if (this.anonymousCouple) {
      this._registryService.emitGenricPopup('anon_signup');
      return;
    }

    if (!this.registry.paid) {
      this._router.navigate(['/visibility']);
    } else {
      this._router.navigate(['/visibility'], { queryParams: { launch: true } });
    }
  }


  savePaymentMethod(type, remove: boolean) {

    // if(this.registry && !this.registry.paid){
    //   this._router.navigate(['/visibility']);
    // }

    switch (type) {
      case 'bank': {
        if (remove) {


          if (this.bank2Country) {
            this.bankCountry = this.bank2Country
            this.bankField1 = this.bank2Field1;
            this.bankField2 = this.bank2Field2;
            this.bankField3 = this.bank2Field3;
            this.bankField4 = this.bank2Field4;
            this.savePaymentMethod('bank2', true)
            this.changeCountryBankField();
            this.changeCountryBankField2();
            this.show3rdBankTransfer = false;

            if (!this.bank2Country) {
              this.show2ndBankTransfer = false;
            }

          } else {

            this.bankField1 = null;
            this.bankField2 = null;
            this.bankField3 = null;
            this.bankField4 = null;
            this.bankCountry = null;
          }
        }
        this.registry.bankField1 = this.bankField1;
        this.registry.bankField2 = this.bankField2;
        this.registry.bankField3 = this.bankField3;
        this.registry.bankField4 = this.bankField4;
        this.registry.bankCountry = this.bankCountry;
        this.addOrRemoveCustomPaymentMethod(type, remove);

        break;
      }

      case 'bank2': {
        if (remove) {


          if (this.bank3Country) {
            this.bank2Country = this.bank3Country
            this.bank2Field1 = this.bank3Field1;
            this.bank2Field2 = this.bank3Field2;
            this.bank2Field3 = this.bank3Field3;
            this.show3rdBankTransfer = false;
            this.show2ndBankTransfer = false;
            this.bank2Field4 = this.bank3Field4;
            this.changeCountryBankField2();
            this.savePaymentMethod('bank3', true)
            this.changeCountryBankField3();
          } else {

            this.bank2Field1 = null;
            this.bank2Field2 = null;
            this.bank2Field3 = null;
            this.bank2Field4 = null;
            this.bank2Country = null;
          }


        }
        this.registry.bank2Field1 = this.bank2Field1;
        this.registry.bank2Field2 = this.bank2Field2;
        this.registry.bank2Field3 = this.bank2Field3;
        this.registry.bank2Field4 = this.bank2Field4;
        this.registry.bank2Country = this.bank2Country;
        this.addOrRemoveCustomPaymentMethod(type, remove);
      }

      case 'bank3': {
        if (remove) {
          this.bank3Field1 = null;
          this.bank3Field2 = null;
          this.bank3Field3 = null;
          this.bank3Field4 = null;
          this.bank3Country = null;
          this.show3rdBankTransfer = false;
        }
        this.registry.bank3Field1 = this.bank3Field1;
        this.registry.bank3Field2 = this.bank3Field2;
        this.registry.bank3Field3 = this.bank3Field3;
        this.registry.bank3Field4 = this.bank3Field4;
        this.registry.bank3Country = this.bank3Country;
        this.addOrRemoveCustomPaymentMethod(type, remove);
      }
      case 'paypal': {
        if (remove) {
          this.paypal = null;
        }
        this.registry.paypal = this.paypal;
        this.addOrRemoveCustomPaymentMethod(type, remove);
        break;
      }
      case 'venmo': {
        if (remove) {
          this.venmo = null;
        }
        this.registry.venmo = this.venmo;
        this.addOrRemoveCustomPaymentMethod(type, remove);
        break;
      }
      case 'custom': {
        if (remove) {
          this.customInstructions = null;
        }
        this.registry.customInstructions = this.customInstructions;
        this.registry.customInstructionsLabel = this.customInstructionsLabel;
        this.addOrRemoveCustomPaymentMethod(type, remove);
        break;
      }
      case 'cashapp': {
        if (remove) {
          this.cashApp = null;
        }
        this.registry.cashApp = this.cashApp;
        this.addOrRemoveCustomPaymentMethod(type, remove);
        break;
      }
      case 'bitcoin': {
        if (remove) {
          this.bitcoin = null;
        }
        this.registry.bitcoin = this.bitcoin;
        this.addOrRemoveCustomPaymentMethod(type, remove);
        break;
      }


      case 'zelle': {
        if (remove) {
          this.zelle = null;
        }
        this.registry.zelle = this.zelle;
        this.addOrRemoveCustomPaymentMethod(type, remove);
        break;
      }

      case 'revolut': {
        if (remove) {
          this.revolut = null;
        }
        this.registry.revolut = this.revolut;
        this.addOrRemoveCustomPaymentMethod(type, remove);
        break;
      }

      case 'cashOnTheDay': {
        if (remove) {
          this.cashOnTheDay = null;
        }
        this.registry.cashOnTheDay = this.cashOnTheDay;
        this.addOrRemoveCustomPaymentMethod(type, remove);
        break;
      }

      case 'wise': {
        if (remove) {
          this.wise = null;
        }
        this.registry.wise = this.wise;
        this.addOrRemoveCustomPaymentMethod(type, remove);
        break;
      }

      case 'payId': {
        if (remove) {
          this.payId = null;
        }
        this.registry.payId = this.payId;
        this.addOrRemoveCustomPaymentMethod(type, remove);
        break;
      }

      case 'chequeOnTheDay': {
        if (remove) {
          this.chequeOnTheDay = null;
        }
        this.registry.chequeOnTheDay = this.chequeOnTheDay;
        this.addOrRemoveCustomPaymentMethod(type, remove);
        break;
      }

      case 'general': {

        if (remove) {
          this.generalInstructions = null;
          this.showGeneralInstructionsEditor = false;
        }
        this.registry.generalInstructions = this.generalInstructions;
        this.editGeneralInstructions = false;

        this.addOrRemoveCustomPaymentMethod(type, remove);
        break;
      }




      default: {

        break;
      }
    }


  }

  handleEnableCreditCardContributions() {
    if (this.USE_PAYENGINE) {
      this._router.navigate(['/registry/add-payment-methods/credit-card']);
    } else {
      this._router.navigate(['/registry/publish/step-2']);
    }
  }
}




// WEBPACK FOOTER //
// ./src/app/account-payment-methods/account-payment-methods.component.ts